import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCustomTable } from "../../services/projectManagementService";

export const getTableColumnDefs = createAsyncThunk(
  "get/archivedProject/list",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await getCustomTable(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
